import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import {
  ErrorDisplayService,
  LoggerService,
} from '@esp-enrollment-form/shared-utils';
import { catchError, throwError } from 'rxjs';

const allowedNotFounds = ['api/aircrafts', 'api/enrollment/contract'];

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const _errorDisplay = inject(ErrorDisplayService);
  const _logger = inject(LoggerService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const message = error.statusText ?? 'An unexpected error occurred';
      _logger.logError(error);

      if (
        !(
          error.status === 404 &&
          allowedNotFounds.some((url) => error.url?.includes(url))
        )
      ) {
        _errorDisplay.showError(message);
        return throwError(() => new Error(message));
      } else {
        return throwError(() => error);
      }
    }),
  );
};
